<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/10/2021
  -->

<template>
	<el-dropdown
		@click="onMainButtonClicked"
		@command="onOptionClicked"
		placement="bottom"
		trigger="click"
		v-bind="$attrs">
		<template #dropdown>
			<div v-if="dropDownTitle" class="p-2 bold font-size-2">
				{{dropDownTitle}}
			</div>

		<el-dropdown-menu :class="{'qw-dropdown-grouped': isGrouped}">
			<template v-for="(section, sectionIndex) in normalizedSections">
				<div
					v-if="section.title"
					:key="`section_title_${sectionIndex}`"
					class="qw-dropdown-section-title pt-2 pb-2"
				>
					{{ section.title }}
				</div>
				<el-dropdown-item
					v-for="(option, index) in section.items"
					:key="`${sectionIndex}_${index}`"
					:command="option"
					:class="{'qw-dropdown-grouped-item': isGrouped}"
					v-bind="option.options"
				>
					<slot name="item" :item="option">
						<div>
							<div>{{ option[labelKey] }}</div>
							<div v-if="option[descriptionKey]"><small class="text-muted">{{ option[descriptionKey] }}</small></div>
						</div>
					</slot>
				</el-dropdown-item>
			</template>
		</el-dropdown-menu>
		</template>

		<template #default>
			<div>
				<slot name="trigger">
					<slot>
						<i class="fontello icon-arrow-combo hover-text"/>
					</slot>
				</slot>
			</div>
		</template>

	</el-dropdown>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwDropdown",
	extends: BaseComponent,
	emits: ["click"],

	props: {
		options: {Array, required: true},
		labelKey: {String, default: "label"},
		descriptionKey: {String, default: "description"},
		dropDownTitle: String,
		primaryOption: Object,
	},
	inheritAttrs: false,

	computed: {
		isGrouped() {
			return !!this.options?.[0]?.items
		},
		normalizedSections() {
			let firstOption = this.options?.[0]
			if (firstOption?.items) {
				return this.options.map(section => ({
					title: section.title || "",
					items: section.items || [],
				}))
			}
			return [{
				title: "",
				items: this.options || [],
			}]
		},
	},

	methods: {
		onOptionClicked(option) {
			let eventName = "Button clicked"
			let title = `'${option[this.labelKey]}'`
			this.$analyticManager.trackEvent(eventName, {...this.analyticsPropsMethod(), title})
			this.$emit("click", option)
		},

		onMainButtonClicked() {
			if(this.primaryOption){
				this.onOptionClicked(this.primaryOption)
			}
		},

		analyticsPropsInternal() {
			return {
				context: "dropdown"
			}
		},
	},
}
</script>

<style lang="scss">
.qw-dropdown-section-title {
	font-size: 12px;
	font-weight: 600;
	color: var(--el-text-color-primary);
	padding-left: 16px;
	padding-right: 16px;
}

.qw-dropdown-grouped .qw-dropdown-section-title + .el-dropdown-menu__item {
	padding-left: 28px;
	padding-right: 20px;
}

.qw-dropdown-grouped .qw-dropdown-grouped-item {
	padding-left: 28px;
	padding-right: 20px;
}

.qw-dropdown-grouped .qw-dropdown-section-title:not(:first-child) {
	margin-top: 6px;
	padding-top: 10px;
	border-top: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
